module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "25",
      "height": "25",
      "viewBox": "0 0 25 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12.5",
      "cy": "12.5",
      "r": "12.5",
      "fill": "#49B263"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.961 14.371C11.9454 14.3869 11.9198 14.387 11.9041 14.3712L8.89441 11.3513C8.72154 11.1778 8.44031 11.1789 8.26875 11.3536L7.83582 11.7947C7.66709 11.9666 7.66793 12.2422 7.83773 12.4131L11.6206 16.2196C11.7934 16.3935 12.0749 16.3926 12.2467 16.2177L18.5045 9.84257C18.6725 9.67143 18.6725 9.39727 18.5045 9.22612L18.0718 8.78536C17.8994 8.60966 17.6163 8.60966 17.4438 8.78536L11.961 14.371Z",
      "fill": "white",
      "stroke": "white",
      "stroke-width": "0.4"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018323e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/forms/icons/ValidIcon.vue
// module id = 655
// module chunks = 0